import { TransactionStatus, TransactionPaymentMethod } from '../../../typings/transaction';

export const PAYMENT_METHOD: Record<TransactionPaymentMethod, TransactionPaymentMethod> = {
  cod: 'cod',
  marketpay: 'marketpay',
};

export const ORDER_STATUS: Record<TransactionStatus, TransactionStatus> = {
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_EXPIRED: 'ORDER_EXPIRED',
  CONTRACT_REQUESTED: 'CONTRACT_REQUESTED',
  CONTRACT_CREATED: 'CONTRACT_CREATED',
  SHIPMENT_LABEL_RECEIVED: 'SHIPMENT_LABEL_RECEIVED',
  PACKAGE_POSTED: 'PACKAGE_POSTED',
  PACKAGE_IN_TRANSIT: 'PACKAGE_IN_TRANSIT',
  PACKAGE_DELIVERED: 'PACKAGE_DELIVERED',
  PACKAGE_REJECTED: 'PACKAGE_REJECTED',
  PAYOUT_PENDING: 'PAYOUT_PENDING',
  PAYOUT_SENT: 'PAYOUT_SENT',
  CONTRACT_CANCELLED: 'CONTRACT_CANCELLED',
  SHIPMENT_ERROR: 'SHIPMENT_ERROR',
  KYC_VERIFICATION_PENDING: 'KYC_VERIFICATION_PENDING',
  SHIPMENT_EXPIRED: 'SHIPMENT_EXPIRED',
  REFUND_SENT: 'REFUND_SENT',
  PACKAGE_READY_TO_PICKUP: 'PACKAGE_READY_TO_PICKUP',
  CONTRACT_EXPIRED: 'CONTRACT_EXPIRED',
  KYC_RETRY_NEEDED_CONFIRMATION: 'KYC_RETRY_NEEDED_CONFIRMATION',
  KYC_RETRY_NEEDED_PAYOUT: 'KYC_RETRY_NEEDED_PAYOUT',
  PACKAGE_PICKUP_EXPIRED: 'PACKAGE_PICKUP_EXPIRED',
  PAYOUT_FAILED: 'PAYOUT_FAILED',
  REFUND_FAILED: 'REFUND_FAILED',
  REFUND_REQUESTED: 'REFUND_REQUESTED',
  DELIVERED_ITEM_REJECTED: 'DELIVERED_ITEM_REJECTED',
  PAYOUT_REQUESTED: 'PAYOUT_REQUESTED',
  SAFEDEAL_ACCEPTED_BY_BUYER: 'SAFEDEAL_ACCEPTED_BY_BUYER',
  SAFEDEAL_BUYER_ACCEPTANCE_EXPIRED: 'SAFEDEAL_BUYER_ACCEPTANCE_EXPIRED',
  SAFEDEAL_REJECTED_BY_BUYER: 'SAFEDEAL_REJECTED_BY_BUYER',
  SAFEDEAL_CS_PAYOUT_REQUESTED: 'SAFEDEAL_CS_PAYOUT_REQUESTED',
  SAFEDEAL_CS_FULL_REFUND_REQUESTED: 'SAFEDEAL_CS_FULL_REFUND_REQUESTED',
  SAFEDEAL_CS_DECISION_EXPIRED: 'SAFEDEAL_CS_DECISION_EXPIRED',
  SAFEDEAL_CS_RETURN_INITIATED: 'SAFEDEAL_CS_RETURN_INITIATED',
};

export const LEGACY_KYC_STATUS: Partial<Record<TransactionStatus | '', TransactionStatus | ''>> = {
  KYC_RETRY_NEEDED_CONFIRMATION: 'KYC_RETRY_NEEDED_CONFIRMATION',
  KYC_RETRY_NEEDED_PAYOUT: 'KYC_RETRY_NEEDED_PAYOUT',
  CONTRACT_REQUESTED: 'CONTRACT_REQUESTED',
};
